































































import gql from 'graphql-tag'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import AppTabBar from '@/components/AppTabBar.vue'
import FilterModal from '@/components/FilterModal.vue'
import TopBar2 from '@/components/TopBar2.vue'
import { CURRENT_USER } from '@/gql/auth'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'
import { MY_USER } from '@/gql/user'
import { Common, ScrollToFetch } from '@/mixins'

@Component({
  components: {
    AppTabBar,
    FilterModal,
    TopBar2
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    myUser: {
      query: MY_USER,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    },
    searchItem: {
      query () {
        return gql`query ($query: String!, $options: AdvancedSearchOptionInput,
          $first: Int, $after: String) {
          searchItem(query: $query, options: $options, first: $first, after: $after) {
            suggestedFilters
            usedFilter
            minPrice
            maxPrice
            isEmpty
            tags {
              id
              name
              type
              medias {
                id
                path
              }
            }
            searchedItemConnection {
              cursor
              hasNextPage
              items {
                ...ItemTileFragment
              }
            }
          }
        }
        ${ITEM_TILE_FRAGMENT}`
      },
      variables () {
        return {
          query: this.$route.query.term,
          options: {
            categories: this.$route.query.categories || [],
            colors: this.$route.query.colors || [],
            excludeSoldOuts: this.booleanQueryValue('excludeSoldOuts', true),
            showOnlyDiscountedItems: this.booleanQueryValue('showOnlyDiscountedItems', false),
            showOnlyTimeSaleItems: this.booleanQueryValue('showOnlyTimeSaleItems', false),
            showPepperOnlyItems: this.booleanQueryValue('showPepperOnlyItems'),
            showOnlyPaybackItems: this.booleanQueryValue('showOnlyPaybackItems'),
            sortSpec: this.$route.query.sortSpec || 'CREATED_AT_DESC',
            minPrice: +this.$route.query.minPrice || undefined,
            maxPrice: +this.$route.query.maxPrice || undefined
          }
        }
      }
    }
  }
})
export default class extends Mixins(Common, ScrollToFetch) {
  @Prop(Array) readonly itemIds!: string[]
  currentUser: { id: string } | null = null
  myUser = {}
  idsSelected: string[] = []
  isFilterModalActive = false
  searchItem = { tags: [], suggestedFilters: [], searchedItemConnection: { items: [] } }

  get currentCategories () {
    return [
      { id: '', name: '전체' },
      ...this.searchItem.suggestedFilters.map(filter => ({ id: filter, name: filter }))
    ]
  }

  mounted () {
    this.idsSelected = [...this.itemIds]
    this.addScrollListener('searchedItemConnection', 'items', 'searchItem')
  }

  onClickItem (id: string) {
    const index = this.idsSelected.indexOf(id)
    if (index > -1) {
      this.idsSelected.splice(index, 1)
    } else {
      this.idsSelected.push(id)
    }
  }

  getRank (id: string) {
    const index = this.idsSelected.indexOf(id)
    return index > -1 ? index + 1 : ''
  }

  beforeDestroy () {
    window.onscroll = null
  }
}
